import React, { Component } from 'react';
import clients from '../../../static/clients';
import { find } from 'lodash';
import { withRouter } from 'react-router-dom';
import { getScrollOpacities } from '../helpers';

class Client extends Component {
  constructor(props){
    super(props);

    this.state = {
      leavingOpacity: 1,
      comingOpacity: 0
    }
  }
  componentWillMount(){
    window.addEventListener('scroll', this.checkScrollPosition);
    window.addEventListener('resize', this.checkScrollPosition);

    document.body.classList.remove('light', 'dark', 'white');

    const { clients } = this.props;
    const client = find(clients, {'slug' : this.props.match.params.slug });

    if(client.acf.background){
      document.body.classList.add(client.acf.background);
    }
  }
  componentDidMount(){
    jQuery('.wp-video video').removeAttr('controls').attr({
      'autoplay': true,
      'loop': true
    });
  }
  componentWillUnmount(){
    window.removeEventListener('scroll', this.checkScrollPosition);
    window.removeEventListener('resize', this.checkScrollPosition);
  }
  checkScrollPosition = event => {
    this.setState(getScrollOpacities(event));
  }
  render() {
    const { clients } = this.props;
    const client = find(clients, {'slug' : this.props.match.params.slug });

    if(!client){
      return <div></div>
    }


    return <div className="client transition">
        <div className="client__breadcrumb" style={{opacity: this.state.comingOpacity}}>
          {client.title.rendered}
        </div>
        <div className="client__title__wrapper" style={{opacity: this.state.leavingOpacity}}>
          <h1 className="client__title">
            {client.title.rendered}
          </h1>
          {client.acf.subtitle &&
            <div className="client__subtitle" dangerouslySetInnerHTML={{__html: client.acf.subtitle}} />
          }
        </div>
        <div className="client__content" dangerouslySetInnerHTML={{__html: client.content.rendered}}>
        </div>
      </div>
  }
}

export default withRouter(Client);
